import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// @ts-ignore No react-router v3.2.1 types
import { push, goBack } from 'react-router-redux';

// Components
import RouteModalRootAuthenticated from '../../../components/modal/RouteModalRootAuthenticated';
import AccountPlanContainer from '../accountModal/plan/AccountPlanContainer';
import { preloadAllCheckoutModals } from './loadableCheckoutComponents';

// Context
import { CheckoutContextProvider } from './context/useCheckoutContext';

// Selectors
import { getCurrentUser, getCurrentUserSubscription } from '../../currentUserSelector';

// Actions
import { fetchCurrentUserSubscription } from '../../currentUserSubscriptionActions';
import { intercomShowMessages } from '../../../analytics/analyticsActions';

// Styles
import './CheckoutModal.scss';

type Route = {
    childRoutes?: Route[];
    path: string;
    component: React.ReactElement;
};

type CheckoutModalProps = {
    children: React.ReactNode;
    route: Route;
    location: {
        pathname: string;
    };
};

const CheckoutModal = ({ children, ...props }: CheckoutModalProps): React.ReactElement => {
    const { location } = props;

    const currentUser = useSelector(getCurrentUser);
    const subscription = useSelector(getCurrentUserSubscription);

    const dispatch = useDispatch();

    const dispatchOpenIntercomMessages = () => dispatch(intercomShowMessages());
    const dispatchFetchSubscriptionDetails = () => dispatch(fetchCurrentUserSubscription());
    const dispatchNavigateTo = (path: string) => dispatch(push(path));
    const dispatchNavigateBrowserBack = () => dispatch(goBack());

    useEffect(() => {
        preloadAllCheckoutModals();
    }, []);

    return (
        <RouteModalRootAuthenticated {...props} className="CheckoutModal auto-width no-padding">
            <AccountPlanContainer {...props}>
                <CheckoutContextProvider
                    currentUser={currentUser}
                    subscription={subscription}
                    dispatchOpenIntercomMessages={dispatchOpenIntercomMessages}
                    dispatchFetchSubscriptionDetails={dispatchFetchSubscriptionDetails}
                    location={location}
                    dispatchNavigateTo={dispatchNavigateTo}
                    dispatchNavigateBrowserBack={dispatchNavigateBrowserBack}
                >
                    {children}
                </CheckoutContextProvider>
            </AccountPlanContainer>
        </RouteModalRootAuthenticated>
    );
};

export default CheckoutModal;
